import { HELPDESKS_TICKETS_URL } from 'constants/ApiConstants';

import * as types from './actionTypes';

/**
 * @param {Object} reportIssue
 * @param {Object} [meta={}]
 * @returns {Object}
 */
export const createReportIssue = (reportIssue, meta = {}) => ({
  type: types.CREATE_REPORT_ISSUE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: HELPDESKS_TICKETS_URL,
      data: reportIssue,
    },
  },
  meta: {
    ...meta,
  },
});

/**
  * @param {Object} [meta={}]
  * @returns {import("./types").OpenReportIssueModalAction}
 */
export const openReportIssueModal = (meta = {}) => ({
  type: types.OPEN_REPORT_ISSUE_MODAL,
  meta,
});
/**
  * @param {Object} [meta={}]
  * @returns {import("./types").OpenReportIssueModalAction}
 */
export const closeReportIssueModal = (meta = {}) => ({
  type: types.CLOSE_REPORT_ISSUE_MODAL,
  meta,
});
